import { PropertySpyListCardListContainer } from "../PropertySpyListCardListContainer"

interface PropertySpyListViewContainerProps {

}

export const PropertySpyListViewContainer = (props: PropertySpyListViewContainerProps): JSX.Element => {
    return (
        <>
            <PropertySpyListCardListContainer></PropertySpyListCardListContainer>
        </>
    )
}